export default __webpack_public_path__ + "static/media/pic2.2cb67d2b.jpg";